/**
 * Created by frank.law on 11/16/17.
 */
import React from 'react';
import '../../../css/login.css';
import {Control} from 'react-redux-form';
import PropTypes from 'prop-types';

class AuthCodeField extends React.Component {

    onChange(event) {
        const {onChangeFunc} = this.props;
        onChangeFunc(event.target.value);
    }

    render() {
        const ControlText = Control.text;
        const {label, placeholder, isError} = this.props;
        let authFieldStyle = "wdc-form-textinput";
        authFieldStyle += (isError) ? " wdc-form-error" : "";

        return (
            <div className="wdc-form-field-wrapper">
                <label className="wdc-form-label wdc-form-label-required">{label}</label>
                <div className="wdc-form-field">
                    <ControlText autoFocus maxLength="8" aria-label={label} model='.authcode' className={authFieldStyle}
                                  placeholder={placeholder} id="authcode" onChange={this.onChange.bind(this)}/>
                </div>
            </div>
        );
    }
}

AuthCodeField.propTypes = {
    onChangeFunc: PropTypes.func,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isError: PropTypes.bool
};

export default AuthCodeField;
